
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7oLij", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7d28922a27cb8f0d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $7d28922a27cb8f0d$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': "Va\u0161e historie chatu je ulo\u017Eena na 30\xa0dn\xed.",
    'ai-mate.chat-error-banner.title': "Zah\xe1jit nov\xfd chat",
    'ai-mate.chat-error.description': "Zkuste <btn>znovu na\u010D\xedst chat</btn>.",
    'ai-mate.chat-error.rate-limited-description': "Dos\xe1hli jste maxim\xe1ln\xedho po\u010Dtu \u017E\xe1dost\xed. Zkuste to znovu pozd\u011Bji.",
    'ai-mate.chat-error.rate-limited-title': "P\u0159\xedli\u0161 mnoho \u017E\xe1dost\xed",
    'ai-mate.chat-error.rovo-inactive-description': "Zd\xe1 se, \u017Ee n\xe1stroj Rovo nen\xed na va\u0161em webu zapnut\xfd. <link>Nastaven\xed n\xe1stroje Rovo</link>",
    'ai-mate.chat-error.rovo-inactive-title': "N\xe1stroj Rovo nen\xed aktivn\xed",
    'ai-mate.chat-error.title': "Nejsme si jist\xed, kde se stala chyba",
    'ai-mate.main-chat.close-chat-button-label': "Zav\u0159\xedt",
    'ai-mate.main-chat.maximize-chat-button-label': "Cel\xe1 obrazovka",
    'ai-mate.main-chat.minimize-chat-button-label': "Obnovit zobrazen\xed",
    'ai-mate.main-chat.new-chat-button-label': "Nov\xe9",
    'ai-mate.main-chat.new-chat-button-label-full-screen': "Nov\xfd chat",
    'conversation-assistant-button.label': 'Chat',
    'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Odeslat',
    'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Zeptejte se na to AI.',
    'highlight-actions.rovo-chat-explain-option.text': "Vysv\u011Btlit",
    'highlight-actions.rovo-chat-explain-prompt': "Vysv\u011Btlete to p\u0159eformulov\xe1n\xedm a\xa0p\u0159id\xe1n\xedm dal\u0161\xedch podrobnost\xed, ale pou\u017E\xedvejte velmi jednoduch\xfd jazyk a\xa0kr\xe1tk\xe9 v\u011Bty a\xa0uve\u010Fte p\u0159\xedklady nebo definice ve\u0161ker\xe9 technick\xe9 terminologie pou\u017E\xedvan\xe9 v\xa0p\u016Fvodn\xed formulaci.",
    'highlight-actions.rovo-chat-find-resources-option.text': "Naj\xedt zdroje",
    'highlight-actions.rovo-chat-find-resources-prompt': "Najd\u011Bte v\xa0r\xe1mci znalost\xed organizace pouze takov\xe9 zdroje, kter\xe9 podporuj\xed u\u010Din\u011Bn\xe1 prohl\xe1\u0161en\xed.",
    'highlight-actions.rovo-chat-give-examples-option.text': "Uv\xe9st p\u0159\xedklady",
    'highlight-actions.rovo-chat-give-examples-prompt': "Uve\u010Fte p\u0159\xedklady ze zdroj\u016F organizace nebo ve\u0159ejn\xfdch znalost\xed. Pokud neexistuj\xed \u017E\xe1dn\xe9 zdroje, kter\xe9 byste mohli poskytnout, zkuste uv\xe9st metaforick\xfd p\u0159\xedklad, kter\xfd by mohl pomoci l\xe9pe tomu porozum\u011Bt.",
    'highlight-actions.rovo-chat-give-feedback-option.text': "Poskytnout zp\u011Btnou vazbu",
    'highlight-actions.rovo-chat-give-feedback-prompt': "Poskytn\u011Bte zp\u011Btnou vazbu t\xedm, \u017Ee zkontrolujete formulaci. Poskytn\u011Bte koment\xe1\u0159 k\xa0v\xfdb\u011Bru slov, gramatice, interpunkci. Bu\u010Fte pozitivn\xed a\xa0energi\u010Dt\xed, ale v\u017Edy uve\u010Fte alespo\u0148 jednu v\u011Bc, kterou by \u0161lo zlep\u0161it nebo zm\u011Bnit.",
    'highlight-actions.rovo-chat-more-options.tooltip': "Doporu\u010Den\xed chatu",
    'highlight-actions.rovo-chat-open-chat.tooltip': "Otev\u0159\xedt chat",
    'highlight-actions.rovo-chat-summarize-option.text': 'Shrnout',
    'highlight-actions.rovo-chat-summarize-prompt': "Zv\xfdrazn\u011Bte kl\xed\u010Dov\xe9 body. Zam\u011B\u0159te se na z\xe1kladn\xed informace a\xa0vylu\u010Dte zbyte\u010Dn\xe9 podrobnosti. Poskytn\u011Bte stru\u010Dn\xfd p\u0159ehled v\xa0jedin\xe9m odstavci.",
    'highlight-actions.rovo-chat.button-text': 'Chat',
    'highlight-actions.rovo-chat.button-text-ask-in-chat': "Zeptat se v\xa0chatu",
    'horizontal-scroll-container.scroll-left': 'Posunout doleva',
    'horizontal-scroll-container.scroll-right': 'Posunout doprava'
};

});


//# sourceMappingURL=cs.17b78de8.js.map
